import { LoadingOutlined } from '@ant-design/icons';

import { Card } from '@atom/card/card';
import { Title } from '@atom/typography/typography';
import { Billing } from '@component/billing/billing';
import { useCurrentApplication } from '@hook/application/use-current-application.hook';
import { isExist } from '@util/data/is-exist';

import { BillingWrapper, TitleWrapper, Wrapper } from './account-plan.style';
import { PlanStats } from './plan-stats/plan-stats';

export const AccountPlan = () => {
  const { current } = useCurrentApplication();

  return (
    <Wrapper>
      <TitleWrapper>
        <Title level={4} mb={6} weight={400}>
          Billing
        </Title>
      </TitleWrapper>
      <Card>
        <PlanStats />
      </Card>
      <BillingWrapper>{isExist(current) ? <Billing /> : <LoadingOutlined />}</BillingWrapper>
    </Wrapper>
  );
};
